import {
  isValidEmail,
  isValidPhone,
  updatePhoneValueSearch,
} from '@sales-center/common'
import {
  IDateRangeFilter,
  IFilterSet,
  IMultiSelectFilter,
  IOrderBy,
  ITernaryFilter,
  normalizeFilters,
  orderByToArray,
} from '@user/components/Filters'
import { DraftLead } from './typings'

export interface DraftLeadFilterSet extends IFilterSet<DraftLead> {
  filters: {
    createdTime: IDateRangeFilter<DraftLead>
    postalCode: IMultiSelectFilter<DraftLead>
    userName: IMultiSelectFilter<DraftLead>
    branchId: IMultiSelectFilter<DraftLead>
    type: IMultiSelectFilter<DraftLead>
    importId: IMultiSelectFilter<DraftLead>
    hasPestPacLocation: ITernaryFilter<DraftLead>
    knockStatusSettingId: IMultiSelectFilter<DraftLead>
  }
}

//#region sorting
export const defaultOrderBy: string = 'createdTime desc,id desc'

export const orderByOptions: IOrderBy[] = [
  {
    label: 'Date Submitted (Newest - Oldest)',
    value: 'createdTime desc,id desc',
  },
  {
    label: 'Date Submitted (Oldest - Newest)',
    value: 'createdTime asc,id asc',
  },
  { label: 'Contact Name (A-Z)', value: 'contactName asc' },
  { label: 'Contact Name (Z-A)', value: 'contactName desc' },
]

export const sortOptionArray = orderByToArray(orderByOptions)
//#endregion

export const defaultFilters: DraftLeadFilterSet = normalizeFilters<
  DraftLead,
  DraftLeadFilterSet
>({
  appliedCount: 0,
  normalizedFilters: [],
  orderBy: defaultOrderBy,
  filters: {
    createdTime: {
      propertyName: 'createdTime',
      type: 'dateRange',
      value: { matchType: 'bt', start: null, end: null },
    },
    postalCode: {
      propertyName: 'postalCode',
      type: 'multiSelect',
      propertyIsArray: false,
      propertyIsString: true,
      startsWith: true,
      value: { mode: 'any', options: [] },
    },
    userName: {
      propertyName: 'userName',
      type: 'multiSelect',
      propertyIsArray: false,
      propertyIsString: true,
      value: { mode: 'any', options: [] },
    },
    branchId: {
      propertyName: 'branchId',
      type: 'multiSelect',
      propertyIsArray: false,
      propertyIsString: true,
      value: { mode: 'any', options: [] },
    },
    type: {
      propertyName: 'type',
      type: 'multiSelect',
      propertyIsArray: false,
      propertyIsString: true,
      value: { mode: 'any', options: [] },
    },
    importId: {
      propertyName: 'importId',
      type: 'multiSelect',
      propertyIsArray: false,
      propertyIsString: false,
      value: { mode: 'any', options: [] },
    },
    hasPestPacLocation: {
      propertyName: 'hasPestPacLocation',
      type: 'ternary',
      value: 'empty',
    },
    knockStatusSettingId: {
      propertyName: 'knockStatusSettingId',
      type: 'multiSelect',
      propertyIsArray: false,
      propertyIsString: false,
      value: { mode: 'any', options: [] },
    },
  },
  search: {
    value: '',
    placeholder: 'Name, email, phone, address',
    searchFields: [
      {
        propertyNames: ['contactName'],
        matchType: 'contains',
        include: /^[^\d]+$/,
      },
      {
        propertyNames: ['emailAddress'],
        matchType: 'eq',
        include: isValidEmail,
      },
      {
        propertyNames: ['phoneNumber', 'mobilePhone', 'altPhoneNumber'],
        matchType: 'eq',
        include: isValidPhone,
        formatter: updatePhoneValueSearch,
      },
      {
        propertyNames: ['contactName', 'company', 'street1'],
        matchType: 'contains',
      },
    ],
  },
})
